import { ProjectConfig } from 'common/types/config'

let sentryNodeDSN = ''
let sentryReactDSN = ''

switch (process.env.NODE_ENV) {
  case 'development':
  case 'test':
    sentryNodeDSN = 'http://cc3f9db9049e4bedb26240c7aa08534b:6bede00cc1bf480982b525dd1a90d48d@10.113.114.134:9000/2'
    sentryReactDSN = 'http://fceafab5977b40deb45347f8a5fd9c30@10.113.114.134:9000/3'
    break
  default:
    sentryNodeDSN = 'https://b7c2d9a6e9ee42a5a12c9d46a2f1d8e4@sentry.shopping.naver.com/5'
    sentryReactDSN = 'https://6689953d1b8f4aeb9f63a56273046189@sentry.shopping.naver.com/4'
}

const config: ProjectConfig = {
  sentryNodeDSN,
  sentryReactDSN,
  // "project" value should be same as src/{project} directory name.
  project: 'pc',
}

export default config
